import { render, staticRenderFns } from "./StatisticsPreview.vue?vue&type=template&id=c78a19fc&scoped=true&"
import script from "./StatisticsPreview.vue?vue&type=script&lang=ts&"
export * from "./StatisticsPreview.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticsPreview.vue?vue&type=style&index=0&id=c78a19fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78a19fc",
  null
  
)

export default component.exports